import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Box, Container, IconButton,
  Avatar, Menu, MenuItem, Divider, Drawer, List, ListItem,
  ListItemButton, ListItemText
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const navPages = [
  { label: 'Home', value: 'home' },
  // { label: 'About Us', value: 'about' },
  // { label: 'Contact', value: 'contact' },
];

export default function Header({ currentPage, setCurrentPage }) {
  // Profile menu dropdown anchor state
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  // Mobile drawer state
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleNavClick = (page) => {
    setCurrentPage(page);
    setMobileOpen(false);
    handleMenuClose();
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: '#ffffff',
        color: '#222222',
        borderBottom: '1px solid #ebebeb',
        top: 0,
        zIndex: 1100,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ height: '80px', justifyContent: 'space-between' }}>
          
          {/* LEFT SIDE: LOGO + BRAND NAME */}
          <Box
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: 1.5 }}
          >
            <img
              src="/logo.jpeg"
              alt="HotelZio Logo"
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                objectFit: 'cover'
              }}
            />
            <Typography
              variant="h5"
              sx={{
                fontWeight: 800,
                letterSpacing: '-0.5px',
                color: '#D4AF37', // Airbnb Coral Accent
                fontFamily: '"Plus Jakarta Sans", sans-serif',
              }}
            >
              Hotel<span style={{ color: '#222222' }}>Zio</span>
            </Typography>
          </Box>

          {/* RIGHT SIDE: AIRBNB-STYLE PROFILE & MENU PILL */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            
            {/* Desktop Profile Pill Trigger */}
            <Box
              onClick={handleMenuOpen}
              sx={{
                display: { xs: 'none', md: 'flex' },
                alignItems: 'center',
                gap: 1.2,
                border: '1px solid #dddddd',
                borderRadius: '30px',
                p: '6px 6px 6px 14px',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                },
              }}
            >
              <MenuIcon sx={{ fontSize: '20px', color: '#595959' }} />
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: '#D4AF37',
                  fontSize: '14px',
                  fontWeight: 700
                }}
              >
                Z
              </Avatar>
            </Box>

            {/* Mobile Hamburger Icon */}
            <IconButton
              onClick={() => setMobileOpen(true)}
              sx={{
                display: { md: 'none' },
                color: '#222222',
                border: '1px solid #dddddd',
                borderRadius: '12px',
                p: '8px'
              }}
            >
              <MenuIcon />
            </IconButton>

          </Box>
        </Toolbar>
      </Container>

      {/* DESKTOP PROFILE DROPDOWN MENU */}
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: '16px',
            mt: 1.5,
            boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
            minWidth: '220px',
            border: '1px solid #ebebeb',
            py: 1
          },
        }}
      >
        {navPages.map((page) => (
          <MenuItem
            key={page.value}
            onClick={() => handleNavClick(page.value)}
            selected={currentPage === page.value}
            sx={{
              fontWeight: currentPage === page.value ? 700 : 500,
              color: currentPage === page.value ? '#D4AF37' : '#222222',
              py: 1.2,
              px: 2.5,
              fontSize: '0.95rem'
            }}
          >
            {page.label}
          </MenuItem>
        ))}
      </Menu>

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{
          sx: {
            width: '80%',
            maxWidth: '320px',
            p: 3,
            bgcolor: '#ffffff'
          }
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding:1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <img
              src="/logo.jpeg"
              alt="HotelZio Logo"
              style={{ width: '32px', height: '32px', borderRadius: '8px' }}
            />
            <Typography variant="h6" fontWeight={800} color="#D4AF37">
              Hotel<span style={{ color: '#222222' }}>Zio</span>
            </Typography>
          </Box>
          
          <IconButton onClick={() => setMobileOpen(false)} sx={{ color: '#717171' }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <List>
          {navPages.map((page) => (
            <ListItem key={page.value} disablePadding sx={{ mb: 1 }}>
              <ListItemButton
                onClick={() => handleNavClick(page.value)}
                selected={currentPage === page.value}
                sx={{
                  borderRadius: '10px',
                  bgcolor: currentPage === page.value ? 'rgba(255, 56, 92, 0.08)' : 'transparent',
                  '&.Mui-selected': {
                    bgcolor: 'rgba(255, 56, 92, 0.08)',
                  }
                }}
              >
                <ListItemText
                  primary={page.label}
                  primaryTypographyProps={{
                    fontWeight: currentPage === page.value ? 700 : 500,
                    color: currentPage === page.value ? '#D4AF37' : '#222222',
                    fontSize: '1.1rem'
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
}